import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { Device } from 'src/app/models/device.model';
import { CustomMessage, mapMessage } from 'src/app/models/enums/custom-message.enum';
import { CookieService } from 'src/app/services/cookieService/cookie.service';
import { DeviceService } from 'src/app/services/device/device.service';
import { SharedService } from 'src/app/services/shared-service/shared.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class HeaderComponent implements OnInit {
  ipadButton!: HTMLElement | null;
  @Output() modalTypeEvent = new EventEmitter<string>();
  currentContinueDeviceClick = false;
  currentSelectedIpad: Device | null = null;
  pairedDevice: Device | null = null;
  currentLoadingState = false;
  buttonName = '';
  isUnitTest = false;

  menuButton!: HTMLElement | null;

  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  @ViewChild('ipadBtn') container!: ElementRef;
  @ViewChild('dropdown') dropdown!: ElementRef;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  constructor(private sharedService: SharedService, private cookieService: CookieService, private deviceService: DeviceService) {
    document.addEventListener('click', this.offClickHandler.bind(this)); // bind on doc
  }
  ngOnInit(): void {
    this.sharedService.currentContinueDeviceClick.subscribe(
      (continueDeviceClick) => (this.currentContinueDeviceClick = continueDeviceClick)
    );
    this.sharedService.currentLoadingState.subscribe((currentLoadingState) => (this.currentLoadingState = currentLoadingState));
    this.sharedService.currentNextButtonName.subscribe((buttonName) => (this.buttonName = buttonName));
    this.sharedService.currentSelectedIpad.subscribe((pairedDevice) => {
      if (pairedDevice && pairedDevice.deviceId != null) {
        this.currentSelectedIpad = pairedDevice;
      }
      this.currentSelectedIpad = pairedDevice;
    });
    this.getPairedDeviceFromCookie('pairedDevice');
  }

  onClick(): void {
    if ((this.currentLoadingState || this.buttonName === 'Done') && this.currentSelectedIpad != null) {
      this.sharedService.updateIpadClick(true);
      this.sharedService.showMessage(mapMessage.get(CustomMessage.WarnChangeDevice));
    } else {
      this.menuButton = document.getElementById('myDropdown');
      this.menuButton?.classList.toggle('show');
    }
  }

  onConnectDevice() {
    this.onEmitModalType('connectIpad');
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  offClickHandler(event: any) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
    if (!this.container.nativeElement.contains(event.target)) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
      if (this.dropdown.nativeElement.className.includes('show')) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
        this.dropdown.nativeElement.classList.remove('show');
      }
    }
  }

  onEmitModalType(modalType: string) {
    this.modalTypeEvent.emit(modalType);
  }

  getPairedDeviceFromCookie(cookieName: string): void {
    const cookieValue = this.cookieService.getCookie(cookieName);

    if (cookieValue != null && cookieValue.length > 0) {
      this.pairedDevice = {
        deviceId: cookieValue,
        connectionId: '',
        eTag: '',
        partitionKey: '',
        rowKey: '',
        timestamp: new Date(),
        uniqueId: '',
      };
    }

    if (this.pairedDevice != null && this.pairedDevice.deviceId != null) {
      this.currentSelectedIpad = this.pairedDevice;
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call
      this.sharedService.updateSelectedIpad(this.pairedDevice);
    }
  }

  onRefreshPos() {
    this.onEmitModalType('spinnerRefreshPos');
    const cookieValue = this.cookieService.getCookie('pairedDevice');
    this.deviceService.deleteDevice(cookieValue).subscribe({
      next: () => {
        setInterval(() => {
          if (this.isUnitTest === false) {
            window.location.reload();
          }
        }, 40000);
      },
      error: (err) => {
        console.log('Delete Device  (ERROR): ');
        console.log(err);
      },
    });
  }
}
